// Fecha de hoy en formato YYYY-MM-DD, en hora de Colombia.
// Evita el bug de que new Date().toISOString() usa UTC y, después de las 7pm
// (UTC-5), ya devuelve el día siguiente. Úsalo para pre-llenar fechas de pago,
// abonos, recibos, etc.
export function hoyColombia() {
  return new Date().toLocaleDateString('en-CA', { timeZone: 'America/Bogota' });
}
